import route from "@/components/router/Router"
const routes = [
    {
        path : "factory-item-add",
        name : "factory-item-add",
        meta : {
            title : "厂房项目-项目录入"
        },
        component: () => import('@/pages/factory/input/Index')
    },
    {
        path : "factory-item-edit/:id",
        name : "factory-item-edit",
        meta : {
            title : "厂房项目-项目录入"
        },
        component: () => import('@/pages/factory/input/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/factory/inputitem/index.js